import { render, staticRenderFns } from "./TeamsCards.vue?vue&type=template&id=83cc979a&scoped=true&"
import script from "./TeamsCards.vue?vue&type=script&lang=js&"
export * from "./TeamsCards.vue?vue&type=script&lang=js&"
import style0 from "./TeamsCards.vue?vue&type=style&index=0&id=83cc979a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cc979a",
  null
  
)

export default component.exports